import { HomeOutlined, UserOutlined, DollarOutlined, CheckCircleOutlined, ApartmentOutlined } from '@ant-design/icons'

export const getMenuItems = (navigate, isMobile, setCollapsed) => {
  const adminMenuItems = [
    {
      key: '/admin',
      icon: <HomeOutlined />,
      label: 'Home',
      onClick: () => {
        navigate('/admin')
        if (isMobile) setCollapsed(true)
      }
    },
    {
      key: '/admin/users',
      icon: <UserOutlined />,
      label: 'Users',
      onClick: () => {
        navigate('/admin/users')
        if (isMobile) setCollapsed(true)
      }
    },
    {
      key: '/admin/transactions',
      icon: <DollarOutlined />,
      label: 'Transactions',
      onClick: () => {
        navigate('/admin/transactions')
        if (isMobile) setCollapsed(true)
      }
    },
    {
      key: '/admin/transaction-approvals',
      icon: <CheckCircleOutlined />,
      label: 'Transaction Approvals',
      onClick: () => {
        navigate('/admin/transaction-approvals')
        if (isMobile) setCollapsed(true)
      }
    },
    {
      key: '/admin/code-graph',
      icon: <ApartmentOutlined />,
      label: 'Code Graph',
      onClick: () => {
        navigate('/admin/code-graph')
        if (isMobile) setCollapsed(true)
      }
    },
  ]

  return adminMenuItems
}